import { render, staticRenderFns } from "./ConvenioCobranzaCard.vue?vue&type=template&id=6d572b35"
import script from "./ConvenioCobranzaCard.vue?vue&type=script&lang=js"
export * from "./ConvenioCobranzaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports